import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac2009',
    ecrans: ['00-2'],
    params:['id']
});

